import { Box, Tab, Tabs } from '@mui/material';
import SavingsCalculator from '@pages/SavingsCalculator/SavingsCalculator';
import Balances from '@pages/balances/Balances';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import ACCOUNT_TABS from './TabsValues';

const TABS_VALUES = {
  BALANCES: 0,
  SAVINGS_CALCULATOR: 1,
};

const MyAccounts = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [selectedTab, setSelecetTab] = useState(TABS_VALUES.BALANCES);

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab && ACCOUNT_TABS.includes(tab)) {
      setSelecetTab(
        tab === ACCOUNT_TABS[TABS_VALUES.BALANCES]
          ? TABS_VALUES.BALANCES
          : TABS_VALUES.SAVINGS_CALCULATOR
      );
    }
  }, [searchParams]);

  return (
    <Box className="p-5">
      <Box>
        <Tabs
          className="bg-white"
          value={selectedTab}
          onChange={(_, value) => setSelecetTab(value)}
        >
          {ACCOUNT_TABS.map((tab) => (
            <Tab key={tab} label={t(tab)} />
          ))}
        </Tabs>
      </Box>
      {selectedTab === TABS_VALUES.BALANCES ? (
        <Balances />
      ) : (
        <SavingsCalculator />
      )}
    </Box>
  );
};

export default MyAccounts;
